export default {
    creditApply: {
        Message: {
            apply: {
                success: 'Credit application submitted successfully!'
            },
            delete: {
                success: 'Deleted successfully!'
            }
        },
        Alert: {
            error: {
                title: 'Notification',
                text: 'Data request failed. Please try again.',
                buttonText: 'OK'
            }
        },
        Description: {
            tabsData: [
                {
                    label: 'Credit Application',
                    value: '0'
                },
                {
                    label: 'Application Records',
                    value: '1'
                }
            ],
            module1: {
                title: 'Credit Application',
                status: ['Under Review', 'Apply for Credit']
            },
            module2: {
                title: 'Application Records',
                table: {
                    headerName: [
                        'Applicant Company',
                        'Application Date',
                        'Approval Status',
                        'Credit Terms',
                        'Remarks'
                    ],
                    rowScope: {
                        text1: 'Credit Limit: ',
                        text2: 'Payment Terms: ',
                        text3: 'Reconciliation Date: ',
                        text4: 'Monthly on ',  // For date formatting
                        text5: 'Weekly on ',
                        text6: 'th'  // Date suffix (e.g., 5th)
                    },
                    noData: 'No data available'
                }
            }
        },
        Confirm: {
            cancel: 'Cancel',
            confirm: 'Confirm',
            title: 'Reminder',
            text: 'Complete identity verification or business authentication before applying for credit. Proceed with authentication?'
        }
    }
}